import { axiosService } from "@/services/AxiosService";

/**
 * @typedef {Object} Breed
 * @property {number} id - ID
 * @property {string} name - Nome

 */

class BreedsService {
    
    path = '/breeds/get-breeds';
    
    constructor() {
        this.axiosInstance = axiosService.getInstance(); // Usa l'istanza di AxiosService
    }

    /**
     * Recupera la lista dei cavalli.
     * @returns {Promise<Breed[]>} - Una promessa che risolve con la lista di cavalli
     * @throws {Error} - Lancia un errore se la chiamata fallisce
     */
    async getBreeds() {
        try {
            const response = await this.axiosInstance.post(this.path);

            if (response.status !== 200) {
                throw new Error('Failed to fetch breeds info');
            }

            /** @type {Breed[]} */
            return response.data.data?.breeds;
        } catch (error) {
            console.error('Error fetching breeds info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

}

export const breedsService = new BreedsService();
